import { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Pencil } from 'lucide-react';

import { ROUTES } from '#/config/routes';
import { Button } from '#/modules/commonComponents/button';
import PurchaseOrderArrivalScheduleCancelCell from '#/modules/srmMgmt/purchaseOrder/components/PurchaseOrderArrivalScheduleCancelCell';
import PurchaseOrderArrivalScheduleConfirmCell from '#/modules/srmMgmt/purchaseOrder/components/PurchaseOrderArrivalScheduleConfirmCell';
import PurchaseOrderArrivalSchedulePreviewDialog from '#/modules/srmMgmt/purchaseOrder/components/PurchaseOrderArrivalSchedulePreviewDialog';
import {
  canEditDraftArrivalSchedule,
  canReceiveArrivalSchedule,
} from '#/modules/srmMgmt/purchaseOrder/helper/arrivalScheduleStatus';

/**
 * 到貨排程列操作：預覽｜編輯(DRAFT)｜確認(DRAFT)｜建入庫｜取消(DRAFT)。
 */
const PurchaseOrderArrivalScheduleActionsCell = ({
  purchaseOrderId,
  schedule,
  onMutated,
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const scheduleId = schedule?.id;
  const showPreview = Boolean(purchaseOrderId && scheduleId);
  const showEdit = canEditDraftArrivalSchedule(schedule?.status)
    && purchaseOrderId
    && scheduleId;
  const showReceive = canReceiveArrivalSchedule(schedule)
    && purchaseOrderId
    && scheduleId;

  return (
    <div className="flex flex-wrap items-center justify-start gap-1.5">
      {showPreview ? (
        <Button
          type="button"
          size="sm"
          className="h-7"
          onClick={() => setPreviewOpen(true)}
        >
          預覽
        </Button>
      ) : null}
      {showEdit ? (
        <Button type="button" size="sm" variant="outline" className="h-7" asChild>
          <Link
            to={ROUTES.purchaseOrderArrivalScheduleEdit(
              purchaseOrderId,
              scheduleId,
            )}
            aria-label="編輯排程"
          >
            <Pencil className="size-3.5" aria-hidden />
            編輯
          </Link>
        </Button>
      ) : null}
      <PurchaseOrderArrivalScheduleConfirmCell
        purchaseOrderId={purchaseOrderId}
        schedule={schedule}
        onMutated={onMutated}
      />
      {showReceive ? (
        <Button type="button" size="sm" variant="outline" className="h-7" asChild>
          <Link
            to={ROUTES.purchaseOrderArrivalInboundCreate(
              purchaseOrderId,
              scheduleId,
            )}
          >
            建入庫
          </Link>
        </Button>
      ) : null}
      <PurchaseOrderArrivalScheduleCancelCell
        purchaseOrderId={purchaseOrderId}
        schedule={schedule}
        onMutated={onMutated}
      />
      {showPreview ? (
        <PurchaseOrderArrivalSchedulePreviewDialog
          open={previewOpen}
          onOpenChange={setPreviewOpen}
          purchaseOrderId={purchaseOrderId}
          scheduleId={scheduleId}
        />
      ) : null}
    </div>
  );
};

PurchaseOrderArrivalScheduleActionsCell.propTypes = {
  purchaseOrderId: PropTypes.string,
  schedule: PropTypes.object,
  onMutated: PropTypes.func,
};

export default PurchaseOrderArrivalScheduleActionsCell;
